export const mobileMedia = "(min-width: 0px) and (max-width: 767px)";
export const tabletMedia = "(min-width: 768px) and (max-width: 1023px)";

export const isMobile = (media = false) => {
  if (typeof window !== "undefined") {
    return window.matchMedia(media || mobileMedia).matches;
  }

  return true;
};

export const isTablet = () => {
  if (typeof window !== "undefined") {
    return window.matchMedia(tabletMedia).matches;
  }

  return true;
};

export const getWinSize = () => {
  if (typeof window !== "undefined") {
    const w = window;
    const d = document;
    const e = d.documentElement;
    const g = d.getElementsByTagName("body")[0];
    const x = w.innerWidth || e.clientWidth || g.clientWidth;
    const y = w.innerHeight || e.clientHeight || g.clientHeight;

    return { width: x, height: y };
  }

  return { width: 0, height: 0 };
};

const timeoutDebounce = {};
export const debounce = (name, func, wait, immediate) => {
  return function () {
    const context = this;
    const args = arguments;

    const later = () => {
      timeoutDebounce[name] = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeoutDebounce[name];

    clearTimeout(timeoutDebounce[name]);

    timeoutDebounce[name] = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};

export const focusLoop = (e, selector) => {
  const tabPressed = e.key === "Tab" || e.keyCode === 9;

  if (!tabPressed) return;

  const elems = document.querySelectorAll(selector);

  if (elems?.length) {
    const firstElem = elems[0];
    const lastElem = elems[elems.length - 1];

    if (!Array.from(elems).includes(document.activeElement)) {
      firstElem.focus();
    }

    if (e.shiftKey) {
      if (document.activeElement === firstElem) {
        lastElem.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastElem) {
        firstElem.focus();
        e.preventDefault();
      }
    }
  }
};

export const getCookieByName = (cookieName) => {
  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(cookieName + "="));
  if (cookieValue === undefined) {
    return null;
  }
  return cookieValue.split("=")[1];
};


export const getUrlParameter = (param) => {
  param = param.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + param + "=([^&#]*)");
  const results = regex.exec(window.location.search);

  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const scrollToSection = (selector, offset = 0) => {
  if (typeof window !== "undefined") {
    const el = document.querySelector(selector);
    if (el) {
      const elementPosition =
        el.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  }
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

export const setSessionStorage = (key, value) => {
  if (typeof window !== "undefined") {
    removeSessionStorage(key);
    sessionStorage.setItem(key, value);
  }
};
export const getSessionStorage = (key) => {
  if (typeof window !== "undefined") {
    return sessionStorage.getItem(key);
  }
  return null;
};
export const removeSessionStorage = (key) => {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(key);
  }
};


/**
 * Convert string to AP Style Title Case
 * Small words are lowercase unless they're the first or last word
 * @param {string} str - String to convert
 * @returns {string} - AP style title cased string
 */
export const convertToApStyleTitleCase = (str) => {
  if (!str) return str;

  // Words that should be lowercase in AP style (unless first/last)
  const smallWords = [
    'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in',
    'into', 'nor', 'of', 'on', 'or', 'the', 'to', 'up', 'with', 'via'
  ];

  // Split on spaces and hyphens but keep the delimiters
  const parts = str.split(/(\s+|-)/);

  return parts.map((part, index) => {
    // Keep whitespace and hyphens as-is
    if (/^\s+$/.test(part) || part === '-') {
      return part;
    }

    // Get the actual word index (excluding spaces/hyphens)
    const wordParts = parts.filter(p => !/^\s+$/.test(p) && p !== '-');
    const wordIndex = wordParts.indexOf(part);
    const isFirst = wordIndex === 0;
    const isLast = wordIndex === wordParts.length - 1;

    // Lowercase the word for comparison
    const lowerPart = part.toLowerCase();

    // Check if it's a small word that should be lowercase
    const isSmallWord = smallWords.includes(lowerPart);

    // Capitalize first letter if: first word, last word, or not a small word
    if (isFirst || isLast || !isSmallWord) {
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    }

    // Otherwise, keep it lowercase
    return lowerPart;
  }).join('');
};
